import React from 'react';
import { Link } from 'react-router-dom';
import SidebarLeftOne from '../../elements/SidebarLeftOne';

const BlogLeftSidebarTwoGridSectionOne = () => {
    return(
        <>
        {/*Blog Section*/}
        <section className="blog-section-nobg section-padding-default">
          <div className="default-container">
            <div className="row clearfix">
              <div className="col-lg-8 order-md-2">
                <div className="row clearfix">
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-01-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar">All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-02-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar">All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-03-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar"> All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-04-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar"> All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-05-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar"> All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-06-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar"> All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-07-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar"> All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-5">
                    <div className="blog-cont-holder">
                      <div className="img_blog">
                        <img src="images/blog/bl-08-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                      </div>
                      <div className="blog-box-detail p-4 text-center">
                        <div className="mt-0">
                          <p className="space-date">January 25</p>
                          <h5 className="font-weight-bold"><Link to="/blog-single-left-sidebar"> All you want to know about  industrial laws</Link></h5>
                          <p>It is a long established fact that a reader will be distracted by the readable content</p>
                          <Link className="read-more text-uppercase font-weight-bold" to="/blog-single-left-sidebar">Read More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <ul className="cr-pagination-center">
                      <li><Link to="#" title><i className="fa fa-angle-left" /></Link></li>
                      <li className="active"><Link to="#" title>1</Link></li>
                      <li><Link to="#" title>2</Link></li>
                      <li><Link to="#" title>3</Link></li>
                      <li><Link to="#" title><i className="fa fa-angle-right" /></Link></li>
                    </ul>
                  </div>
                </div>
              </div>

              <SidebarLeftOne />

            </div>
          </div>
        </section>
        {/*End Blog Section*/}
        </>
    )
}

export default BlogLeftSidebarTwoGridSectionOne;